export default __webpack_public_path__ + "static/media/dolby_main.d908f018.jpeg";